<script setup>
import { ref, computed, watch } from 'vue';
import { useStore } from 'dashboard/composables/store';
import { useI18n } from 'vue-i18n';
import powerDataAPI from 'dashboard/api/powerData';
import Dialog from 'dashboard/components-next/dialog/Dialog.vue';
import Input from 'dashboard/components-next/input/Input.vue';

const props = defineProps({ store: { type: Object, default: null } });
const emit = defineEmits(['created', 'updated']);

const { t } = useI18n();
const appStore = useStore();

const dialogRef = ref(null);
const name = ref('');
const isLoading = ref(false);

const isEdit = computed(() => Boolean(props.store?.id));

watch(
  () => props.store,
  val => {
    name.value = val?.name || '';
  },
  { immediate: true }
);

async function submit() {
  if (!name.value.trim()) return;
  isLoading.value = true;
  const accountId = appStore.getters.getCurrentAccountId;
  try {
    if (isEdit.value) {
      await powerDataAPI.update(accountId, props.store.id, {
        name: name.value.trim(),
      });
      emit('updated');
    } else {
      await powerDataAPI.create(accountId, { name: name.value.trim() });
      emit('created');
    }
    dialogRef.value?.close();
    name.value = '';
  } finally {
    isLoading.value = false;
  }
}

defineExpose({
  dialogRef,
  open: () => dialogRef.value?.open(),
  close: () => dialogRef.value?.close(),
});
</script>

<template>
  <Dialog
    ref="dialogRef"
    width="md"
    :title="isEdit ? t('POWER_DATA.RENAME') : t('POWER_DATA.CREATE')"
    :confirm-button-label="
      isEdit ? t('POWER_DATA.SAVE') : t('POWER_DATA.CREATE')
    "
    :cancel-button-label="t('POWER_DATA.CANCEL')"
    :disable-confirm-button="!name.trim()"
    :is-loading="isLoading"
    @confirm="submit"
  >
    <!-- Sem @enter aqui de propósito. O conteúdo do Dialog vive dentro de um
         <form @submit.prevent="confirm">, então o Enter já dispara o submit no
         keydown; o Input emite `enter` no keyup, sem preventDefault. Ligar os
         dois fazia DOIS POST e criava a base duplicada. -->
    <Input
      v-model="name"
      :label="t('POWER_DATA.NAME')"
      :placeholder="t('POWER_DATA.NAME_PLACEHOLDER')"
    />
  </Dialog>
</template>
